import { FC, ReactNode } from "react";
import { Flex, HStack, Box } from "@chakra-ui/react";

export interface FiltroBarProps {
  /** Controles à esquerda (dropdowns de contexto/status, busca com lupa). */
  children?: ReactNode;
  /** Ação primária à direita (botão vermelho) — opcional (só quando houver). */
  action?: ReactNode;
}

// Barra de filtros no padrão Rede Frota - Cardan: uma linha ACIMA da tabela,
// controles à esquerda e (opcionalmente) um botão de ação primário à direita.
// Espaçamento generoso, tudo alinhado numa linha, com wrap no mobile.
export const FiltroBar: FC<FiltroBarProps> = ({ children, action }) => (
  <Flex
    mb="16px"
    gap="12px"
    align={{ base: "stretch", md: "flex-end" }}
    justify="space-between"
    wrap="wrap"
    direction={{ base: "column", md: "row" }}
  >
    <HStack spacing="12px" wrap="wrap" align="flex-end">
      {children}
    </HStack>
    {action && <Box flexShrink={0}>{action}</Box>}
  </Flex>
);
